import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'
import Auth from './ui/Templates/Auth/Auth'
import Dashboard from './ui/Templates/Dashboard/Dashboard'
import {
    GENERAL_LOGIN_PATH,
    GENERAL_FORGOTTEN_PASSWORD_PATH,
    GENERAL_RESET_PASSWORD_PATH,
    GENERAL_SETTINGS,
    MEMSOURCE_PROJECTS_DETAILS_PATH,
    MEMSOURCE_PROJECTS_LIST_PATH,
    MEMSOURCE_JOBS_LIST_PATH,
    TEMPO_DASHBOARD_PATH,
    TEMPO_PROJECTS_LIST_PATH,
    TEMPO_QUOTES_CREATE_PATH,
    TEMPO_QUOTES_LIST_PATH,
    TEMPO_QUOTES_UPDATE_PATH,
    TEMPO_REPORTING_PATH,
    TEMPO_STUDIES_PATH,
    TEMPO_TERMINOLOGY_PATH,
    TEMPO_VALIDATION_PATH,
    TEMPO_PROJECT_DETAILS_PATH,
    XTRF_PROJECTS_DETAILS_PATH,
    XTRF_PROJECTS_LIST_PATH,
    XTRF_PROJECTS_NEW_PATH,
    XTRF_QUOTE_LIST_PATH,
    XTRF_REPORTS_PATH,
} from './config/pathList'

export const routes = [
    {
        path: '/auth',
        component: Auth,
        routes: [
            {
                path: GENERAL_LOGIN_PATH,
                exact: false,
                component: lazy(() => import('./ui/Pages/AUTH/Login/Login')),
            },
            {
                path: GENERAL_FORGOTTEN_PASSWORD_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/AUTH/ForgottenPassword/ForgottenPassword')),
            },
            {
                path: GENERAL_RESET_PASSWORD_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/AUTH/ResetPassword/ResetPassword')),
            },
        ],
    },
    {
        route: '*',
        component: Dashboard,
        routes: [
            {
                path: GENERAL_SETTINGS,
                exact: true,
                component: lazy(() => import('./ui/Pages/Settings/Settings')),
            },
            {
                path: XTRF_REPORTS_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/Reports/Reports')),
            },
            {
                path: XTRF_PROJECTS_NEW_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/XTRF/NewProjectForm/NewProjectForm')),
            },
            {
                path: XTRF_PROJECTS_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/XTRF/ListProjects/ListProjects')),
            },
            {
                path: XTRF_QUOTE_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/XTRF/ListQuotes/ListQuotes')),
            },
            {
                path: XTRF_PROJECTS_DETAILS_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/XTRF/ProjectDetails/ProjectDetails')),
            },
            {
                path: MEMSOURCE_PROJECTS_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/MEMSOURCE/ListProjects/ListProjects')),
            },
            {
                path: MEMSOURCE_PROJECTS_DETAILS_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/MEMSOURCE/ProjectDetails/ProjectDetails')),
            },
            {
                path: MEMSOURCE_JOBS_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/MEMSOURCE/ListJobs/ListJobs')),
            },
            {
                path: TEMPO_PROJECTS_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/ListProjects/ListProjects')),
            },
            {
                path: TEMPO_PROJECT_DETAILS_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/ProjectDetails/ProjectDetails')),
            },
            {
                path: TEMPO_DASHBOARD_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/Dashboard/Dashboard')),
            },
            {
                path: TEMPO_VALIDATION_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/Validation/Validation')),
            },
            {
                path: TEMPO_TERMINOLOGY_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/Terminology/Terminology')),
            },
            {
                path: TEMPO_REPORTING_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/Reporting/Reporting')),
            },
            {
                path: TEMPO_STUDIES_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/Studies/StudyDetails')),
            },
            {
                path: TEMPO_QUOTES_LIST_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/ListQuotes/ListQuotes')),
            },
            {
                path: TEMPO_QUOTES_CREATE_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/NewProjectForm/NewProjectForm')),
            },
            {
                path: TEMPO_QUOTES_UPDATE_PATH,
                exact: true,
                component: lazy(() => import('./ui/Pages/TEMPO/NewProjectForm/NewProjectForm')),
            },
            {
                component: () => <Redirect to="/" />,
            },
        ],
    },
]
